{
  "translation": {
    "attribute photo": "{{platform}}の{{author}}による写真。",
    "home": {
      "welcome to": "{{name}}へようこそ。",
      "start": "計画を開始する",
      "why": {
        "why": "なぜ{{name}}?",
        "1": "最も効率的なパネル配置を計算します。",
        "2": "時間の経過とともにコストを見積もります。",
        "3": "緯度、方向などを考慮します。",
        "4": "100％無料で使いやすい。"
      }
    },
    "404": {
      "not found": "ページが見つかりませ",
      "go home": "帰る"
    },
    "about": {
      "title": "ついて ",
      "repo": "GitHubでリポジトリを表示.",
      "changelog": "変更ログを表示します。",
      "made with": "で作った",
      "authors": "{{authors}}で<0></0>で作られました.",
      "exit": "終了するには、任意の場所をクリックします."
    },
    "planner": {
      "next step": "次のステップ",
      "location": {
        "title": "場所の設定",
        "latitude": "建物の緯度。",
        "shading": "屋根の影の量。",
        "direction": "屋根の方向。"
      },
      "finance": {
        "title": "財務設定",
        "energy usage": "あなたの家庭が年間どのくらいのエネルギーを消費するか。",
        "energy cost": "エネルギーの1kWhのコスト。",
        "seg": "1kWhの余剰電力に対していくら支払われますか。",
        "seg info": "後で戻って確認",
        "seg desc": "",
        "energy info": "",
        "energy desc": ""
      },
      "roof": {
        "title": "屋根のセクション",
        "add section": "セクションを追加"
      },
      "overview": {
        "title": "パネルと概要を選択",
        "panels": "パネル",
        "overview": "概要",
        "roof area": "屋根面積: {{area}}m²",
        "panel area": "パネル面積：5m²({{count}}パネル、<0>{{efficiency}}%スペース効率</0>)",
        "initial cost": "初期費用: £{{cost}}",
        "labor cost": "人件費: £{{cost}}",
        "estimated energy": "推定エネルギー: {{energy}}kW（{{efficiency}}%効率）",
        "annual energy": "年間エネルギー: {{energy}}kWh",
        "annual profits": "年間利益: £{{profit}}",
        "return on investment": "投資収益率: {{roi}} years",
        "best": "最高の年間利益",
        "annual savings": "年間節約: £{{saving}}",
        "error no sections": "屋根セクションはまだ作成されていません。",
        "error no space": "このタイプのパネルは適合できません。"
      }
    },
    "common": {
      "tagline": "最先端のソーラーパネルプランナー。",
      "latitude": "緯度",
      "shading": "影",
      "direction": "方向",
      "energy usage": "エネルギー使用量",
      "energy cost": "エネルギーコスト",
      "seg": "スマートな輸出保証",
      "width": "幅",
      "height": "高さ",
      "gradient": "勾配",
      "dimensions": "寸法",
      "area": "面積",
      "price": "価格"
    },
    "adjs": {
      "none": "なし",
      "little": "ほとんどありません",
      "modest": "適度",
      "significant": "重要",
      "heavy": "大量",
      "full": "完全にカバー"
    },
    "geo": {
      "northern": "北半球",
      "southern": "南半球",
      "equator": "赤道",
      "n": "北",
      "ne": "北東",
      "e": "東",
      "se": "南東",
      "s": "南",
      "sw": "南西",
      "w": "西",
      "nw": "北西"
    }
  }
}
